export const SELECT_JENIS_DOKUMEN = "@jenisDokumen/SELECT_USER";

export const INITIALIZE_CREATE_JENIS_DOKUMEN = "@jenisDokumen/INITIALIZE_CREATE_JENIS_DOKUMEN";

export const UPDATE_NAME = "@jenisDokumen/UPDATE_NAME";
export const UPDATE_STATUS = "@jenisDokumen/UPDATE_STATUS";
export const UPDATE_PARENT = "@jenisDokumen/UPDATE_PARENT";
export const UPDATE_KODE = "@jenisDokumen/UPDATE_KODE";

export const GET_JENIS_DOKUMEN_REQUEST = "@jenisDokumen/GET_JENIS_DOKUMEN_REQUEST";
export const GET_JENIS_DOKUMEN_SUCCESS = "@jenisDokumen/GET_JENIS_DOKUMEN_SUCCESS";
export const GET_JENIS_DOKUMEN_FAILURE = "@jenisDokumen/GET_JENIS_DOKUMEN_FAILURE";

export const GET_DETAIL_JENIS_DOKUMEN_REQUEST = "@jenisDokumen/GET_DETAIL_JENIS_DOKUMEN_REQUEST";
export const GET_DETAIL_JENIS_DOKUMEN_SUCCESS = "@jenisDokumen/GET_DETAIL_JENIS_DOKUMEN_SUCCESS";
export const GET_DETAIL_JENIS_DOKUMEN_FAILURE = "@jenisDokumen/GET_DETAIL_JENIS_DOKUMEN_FAILURE";

export const UPDATE_JENIS_DOKUMEN_REQUEST = "@jenisDokumen/UPDATE_JENIS_DOKUMEN_REQUEST";
export const UPDATE_JENIS_DOKUMEN_SUCCESS = "@jenisDokumen/UPDATE_JENIS_DOKUMEN_SUCCESS";
export const UPDATE_JENIS_DOKUMEN_FAILURE = "@jenisDokumen/UPDATE_JENIS_DOKUMEN_FAILURE";

export const CREATE_JENIS_DOKUMEN_REQUEST = "@jenisDokumen/CREATE_JENIS_DOKUMEN_REQUEST";
export const CREATE_JENIS_DOKUMEN_SUCCESS = "@jenisDokumen/CREATE_JENIS_DOKUMEN_SUCCESS";
export const CREATE_JENIS_DOKUMEN_FAILURE = "@jenisDokumen/CREATE_JENIS_DOKUMEN_FAILURE";